import { render, staticRenderFns } from "./ViewedBy.vue?vue&type=template&id=3b30ba6a&scoped=true&"
import script from "./ViewedBy.vue?vue&type=script&lang=js&"
export * from "./ViewedBy.vue?vue&type=script&lang=js&"
import style0 from "./ViewedBy.vue?vue&type=style&index=0&id=3b30ba6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b30ba6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
